<template>
  <h2 :class="$style.title">最近購入された作品</h2>
  <template v-if="isLoaded">
    <ul v-if="items.length > 0" :class="$style.list">
      <li v-for="item in items" :key="item.itemId">
        <a :href="`/listing/item/${item.itemId}`">
          <img :src="itemImageUrl(item.picture?.imagePath || '')" :alt="item.title" width="155" height="155" loading="lazy" />
        </a>
        <div :class="$style.name">
          <a :href="`/listing/item/${item.itemId}`">{{ item.title }}</a>
        </div>
        <div>&yen;{{ item.price.toLocaleString() }}</div>
      </li>
    </ul>
    <p v-else :class="$style.noItems">最近購入された作品はありません</p>
  </template>
</template>

<script setup lang="ts">
import type { ItemForList } from '@iichi/schema-api-v2/entities/item';
import { ref, onMounted } from 'vue';
import { dynamicImageUrl } from '@/js/lib/helper/url';
import { get as getRecentlySoldItems } from '@/js/lib/api/v2/public/items/recent-sold';

const props = defineProps<{
  categoryId?: number;
  isVintage?: boolean;
}>();
const isLoaded = ref(false);
const items = ref<ItemForList[]>([]);
const itemImageUrl = (imagePath: string) => dynamicImageUrl(imagePath, 310, 310);
const loadItems = async () => {
  const { data } = await getRecentlySoldItems({ categoryId: props.categoryId, isVintage: props.isVintage });
  items.value.push(...data);
  isLoaded.value = true;
};

onMounted(() => {
  loadItems();
});
</script>

<style module lang="scss">
.title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;

  @media (--sp) {
    margin-bottom: 10px;
  }
}

.list {
  display: flex;
  gap: 10px;
  overflow-x: auto;

  @media (--sp) {
    margin: 0 -10px;
    padding: 0 0 0 10px;
  }

  > li {
    min-width: calc(15.4% - 10px);
    padding-bottom: 12px;
    position: relative;
    width: calc(15.4% - 10px);

    @media (--sp) {
      min-width: calc(28.6% - 10px);
      width: calc(28.6% - 10px);
    }

    &:last-child::after {
      content: '';
      height: 1px;
      left: 100%;
      position: absolute;
      top: 0;
      width: 10px;
    }

    img {
      height: auto;
      width: 100%;
    }

    .name {
      margin-top: 6px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.noItems {
  align-items: center;
  background-color: var(--color-gray100);
  display: flex;
  justify-content: center;
  min-height: 200.91px;

  @media (--sp) {
    min-height: calc(28.6vw + 47.14px); // 画像の高さが可変なので計算済みの値を設定
  }
}
</style>
